import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useMediaQuery, useTheme } from '@mui/material';
import { COLORS } from '../../themev2';

type MobileMenuButtonProps = {
  onClick: () => void;
  isAdmin?: boolean;
};

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ onClick, isAdmin }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  if (isMdUp) {
    return null;
  }

  return (
    <IconButton
      onClick={onClick}
      sx={{
        color: isAdmin ? COLORS.brand.paper : COLORS.gray[1400],
        position: 'fixed',
        top: 16,
        left: 16,
        zIndex: 1200,
        backgroundColor: isAdmin ? '#065570' : COLORS.brand.paper,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
        '&:hover': {
          backgroundColor: isAdmin ? '#065570' : COLORS.brand.paper,
        },
        // Add height and width for better touch target
        height: 40,
        width: 40,
      }}
    >
      <MenuIcon />
    </IconButton>
  );
};

export default MobileMenuButton;
